/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { customTokenRefreshRequestSchema } from "./customTokenRefreshRequestSchema.ts";
import { customTokenRefreshSchema } from "./customTokenRefreshSchema.ts";

export const userTokenRefreshCreateStatus200Schema = customTokenRefreshSchema;

export const userTokenRefreshCreateResponseSchema = userTokenRefreshCreateStatus200Schema;

export const userTokenRefreshCreateDataSchemaJson = customTokenRefreshRequestSchema;

export const userTokenRefreshCreateDataSchemaXml = customTokenRefreshRequestSchema;

export const userTokenRefreshCreateDataSchema = z.union([userTokenRefreshCreateDataSchemaJson, userTokenRefreshCreateDataSchemaXml]);
